import { createContext } from 'react';

import { type SearchBoxProps } from './SearchBox.types';

export const SearchBoxContext = createContext<SearchBoxProps>({});
